// extracted by mini-css-extract-plugin
export var groupTabs = "TabGroup-module--groupTabs--5e4b1";
export var isScrolling = "TabGroup-module--isScrolling--ea5e2";
export var slider = "TabGroup-module--slider--6ca97";
export var sliderActive = "TabGroup-module--sliderActive--b0485";
export var wrapper = "TabGroup-module--wrapper--abd55";